<template>
  <v-row>
    <v-col>
      <v-autocomplete
        :items="statusTypes"
        :rules="[required]"
        item-text="key"
        item-value="value"
        outlined
        label="Status"
        v-model="status"
      />
    </v-col>
  </v-row>
</template>

<script>
import { sync } from 'vuex-pathify'
import replacementStatus from '../../../../common/replacementStatus'
import { required } from '@/common/validationRules'

export default {
  name: 'ReplacementStatusField',

  data: () => ({
    required,
    replacementStatus
  }),

  computed: {
    status: sync('replacement/model@status'),
    statusTypes() {
      return Object.entries(replacementStatus).map(([k, v]) => ({
        key: v,
        value: k
      }))
    }
  }
}
</script>
